import { Component, OnInit, WritableSignal, signal, computed } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { DatePickerModule } from 'primeng/datepicker';
import { TextareaModule } from 'primeng/textarea';
import { RadioButtonModule  } from 'primeng/radiobutton';
import { FeedbackService } from '../../../../../../shared/services/componentsServices/feedback.service';
import { givenFeedbackModel, givenFeedbackField, runsDataByUserRequest, currentFeedbackModel, closingTradeData } from '../../../../../../shared/models/serviceModels/request/feedbackReq.model';
import { feedbackFormsData, feedbackDataSetValues, prediction} from '../../../../../../shared/models/serviceModels/response/feedbackRes.model';
import {StandardDropdown} from '../../../../../../shared/models/components/dropdowns/standardDropdown.models';
import { DividerModule } from 'primeng/divider';
import { openTradesDataSet } from '../../../../../../shared/models/serviceModels/openTradesDataSet.model';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-close-trade-form',
    standalone: true,
    imports: [SelectModule,
        FormsModule,
        CommonModule,
        DividerModule,
        FontAwesomeModule,
        DatePickerModule,
        TextareaModule,
        RadioButtonModule],
    templateUrl: './close-trade-form.component.html',
    styleUrl: './close-trade-form.component.scss'
})

export class CloseTradeFormComponent implements OnInit {
  tradeDate: WritableSignal<string> = signal('');
  tradePrice: WritableSignal<string> = signal('');
  closingPrice: number = 0;
  tradeDirection: WritableSignal<string> = signal('');
  tradeContract: WritableSignal<string> = signal('');
  tradeLots: WritableSignal<string> = signal('');
  // reason_stop_loss: WritableSignal<string> = signal('');
  // reason_take_profit: WritableSignal<string> = signal('');
  closingDate: Date | undefined;
  // closingReason: number | undefined;
  closingReasonModel: string = '';
  freeText: string = '';

  tradePriceNotValid: WritableSignal<boolean> = signal(false);
  feedbackFormData:  WritableSignal<feedbackFormsData | null>  = signal(null);
  openTradesDropdown:  WritableSignal<StandardDropdown[]>  = signal([]);
  selectedTrade: StandardDropdown= {description: "", value: ""};
  private currentFeedback: currentFeedbackModel = { feedbackFields: [], userId: "", userRoleId: 1, feedbackDate: new Date(), feedbackTypeId: 1};
  areOpenTradesLoading=false;
  faSpinner: IconDefinition = faSpinner;

  openTradesData: WritableSignal<openTradesDataSet[] | null>  = signal(null);

  isFieldDisabled = computed(() => {
    return this.feedbackService.getFieldsStatus();
  })

  constructor (
    library: FaIconLibrary,
    private feedbackService: FeedbackService
  ) {
    library.addIconPacks(fas);
  }

  ngOnInit(): void {

    const singleData = this.feedbackService.getFormData()();

    this.feedbackFormData.set(singleData ? singleData : null);

    this.setDefaultValues();

    this.getOpenTrades();
  }

  setDefaultValues() {
   
    const defaultFeedbackData = this.feedbackService.getFeedbackBeforeSubmit();
    this.currentFeedback = defaultFeedbackData? defaultFeedbackData : this.currentFeedback;

  }

  getOpenTrades(){
    const userId = this.currentFeedback.userId;

    const openTradesRequest = {
      userId: userId
    };
    this.areOpenTradesLoading=true;

    this.feedbackService.getOpenTrades(openTradesRequest).subscribe({
      next: (response) => {
        this.areOpenTradesLoading=false;
        const openTradesData = response.openTradesDataSet || [];
        
        const sortedTrades = [...openTradesData].sort((a, b) => {
          const dateA = a.tradeDate ? new Date(a.tradeDate).getTime() : 0;
          const dateB = b.tradeDate ? new Date(b.tradeDate).getTime() : 0;
          return dateB - dateA;
        });

        this.openTradesData.set(sortedTrades);

        const dropdownOptions: StandardDropdown[] = [];

        sortedTrades.forEach(trade => {

            const formattedDate = trade.tradeDate?
             new Date(trade.tradeDate).toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
            })
            : new Date().toLocaleDateString('en-US');

            let newOption: StandardDropdown = {
              description: `Trade Date: ${formattedDate} - Contract: ${trade.contract} `,
              value: trade.id?.toString() || ''
              }

            dropdownOptions.push(newOption);
        });

        this.openTradesDropdown.set(dropdownOptions);
      },
      error: (error) => {
        this.areOpenTradesLoading=false;
        console.error('Error fetching open trades:', error);
      }
    })
  }

  // setTradeDataInFeedbackModel(selectedTrade: openTradesDataSet){

  //   this.currentFeedback= {
  //     ...this.currentFeedback,
  //     closingTradeData: {
  //       ...this.currentFeedback.closingTradeData,
  //       tradeDate: selectedTrade.tradeDate,
  //       tradeDirection: this.tradeDirection(),
  //       tradeContract: this.tradeContract(),
  //       tradeEntryPrice: selectedTrade.entryPrice,
  //       tradeLots: selectedTrade.lots
  //   }};

  // }

  onTradeSelectionChange(event: any) {

    let openTrades = this.openTradesData();
    let selectedTradeId = parseInt(event.value.value);
    let selectedTrade = openTrades?.find(trade => trade.id === selectedTradeId);

    if(selectedTrade){
       this.setTradeDataInUi(selectedTrade);
       this.storeInputsValuesIntoFeedbackResponse(selectedTradeId, 'open_trade_id');
       
       this.checkIfAllMandatoryFieldsAreFilled();
    }

    // this.isPredictedPriceDisabled = true;

    // let formData= this.feedbackFormData();

    // this.givenFeedbackResponse = {
    //   ...this.givenFeedbackResponse,
    //   predictionSourceTypeId: formData?.predictionSourceType?.feedbackFieldValues?.find(type => type.field?.toLowerCase() === "prediction".toLowerCase())?.id,
    //   predictionRunId: event.value.value,
    //   predictionRunDate: new Date(event.value.description)
    // };

    // this.feedbackService.setFeedbackValues(this.givenFeedbackResponse!);
    // this.getPredictionData();
  }



  setTradeDataInUi(currentTrade: openTradesDataSet){
    const formFieldsData = this.feedbackFormData();

    let currentDirectionText= formFieldsData?.directions?.feedbackFieldValues?.find(item => item.id === currentTrade.directionId)?.field;

    this.tradePrice.set(currentTrade.entryPrice ? currentTrade.entryPrice.toString() : '');
    this.tradeDirection.set(currentDirectionText ? currentDirectionText : '');
    this.tradeContract.set(currentTrade.contract ? currentTrade.contract : '');
    this.tradeLots.set(currentTrade.lots ? currentTrade.lots.toString() : '');

    this.currentFeedback={...this.currentFeedback,
      closingTradeData: {
        ...this.currentFeedback.closingTradeData,
        tradeDate: currentTrade.tradeDate,
        tradeDirection: currentDirectionText ? currentDirectionText : '',
        tradeContract: currentTrade.contract ? currentTrade.contract : '',
        tradeEntryPrice: currentTrade.entryPrice,
        tradeLots: currentTrade.lots
      }
    };
  }


  onClosingDateChange(event: any) {
    const closingDate = new Date(event);
    this.closingDate= closingDate;

    this.currentFeedback= {
      ...this.currentFeedback,
      closingTradeData: {
        ...this.currentFeedback.closingTradeData,
        closingDate: closingDate
      }
    };

    this.feedbackService.setFeedbackValues(this.currentFeedback);
    this.checkIfAllMandatoryFieldsAreFilled();
  }

  validateClosingPrice(event:any){
    let closingPrice = event.currentTarget.value;

    if (closingPrice === ""|| isNaN(closingPrice) || closingPrice <= 0) {
      this.closingPrice = 0; // Clear the model
      this.tradePriceNotValid.set(true);
      this.checkIfAllMandatoryFieldsAreFilled();
      return;
    }

    this.closingPrice = closingPrice;
    this.tradePriceNotValid.set(false);

    this.storeInputsValuesIntoFeedbackResponse(closingPrice, 'closing_price');
    this.checkIfAllMandatoryFieldsAreFilled();
  }

  storeClosingPriceValue(event:any){

    // let closingPrice = event.currentTarget.value;

    // if (isNaN(closingPrice) || closingPrice <= 0) {
    //   this.closingPrice = 0; // Clear the model
    //   this.tradePriceNotValid.set(true);
    //   return;
    // }

    // this.closingPrice = closingPrice;
    // this.tradePriceNotValid.set(false);

    // this.storeInputsValuesIntoFeedbackResponse(closingPrice, 'closing_price');
    // this.checkIfAllMandatoryFieldsAreFilled();
  }


  onReasonChange(){

    const formFieldsData = this.feedbackFormData();
    let formFeedbackField = formFieldsData?.closingReasons?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === this.closingReasonModel.toString().toLowerCase());

    if(formFeedbackField){
      this.storeInputsValuesIntoFeedbackResponse(formFeedbackField?.id ?? 0, 'reason');
      this.checkIfAllMandatoryFieldsAreFilled();
    }

  }

  onFreeTextEntered(){
    // let freeText = this.freeText;

    // // Validate that the text contains only plain text and no malicious code
    // const sanitizedText = freeText.replace(/[^a-zA-Z0-9 .,!?'"()-]/g, '');

    // this.storeFreeText(sanitizedText);
    // this.checkIfAllMandatoryFieldsAreFilled();
  }

  validateFreeText(event:any){
    let freeText = this.freeText;

    // Validate that the text contains only plain text and no malicious code
    const sanitizedText = freeText.replace(/[^a-zA-Z0-9 .,!?'"()\-$/#@]/g, '');
    // const sanitizedText = freeText.replace(/[^a-zA-Z0-9 .,!?'"()\-$/]/g, '');
    // const sanitizedText = freeText.replace(/[^a-zA-Z0-9 .,!?'"()-]/g, '');


    const wordCount = sanitizedText.trim().split(/\s+/).length;
    this.checkIfAllMandatoryFieldsAreFilled();

    if (wordCount >= 2) {
      this.storeFreeText(sanitizedText);
    }

    // this.storeFreeText(sanitizedText);
    // this.checkIfAllMandatoryFieldsAreFilled();
  }

  storeFreeText(freeText: string){

    const formFieldsData = this.feedbackFormData();
    let formFeedbackField = formFieldsData?.feedbackFields?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === "free_text".toLowerCase());

    let feedbackField: givenFeedbackField = {
      dataTypeId: formFeedbackField?.dataTypeId || 0,
      fieldId: formFeedbackField?.id,
      fieldName: formFeedbackField?.field || "",
      fieldDescription: formFeedbackField?.description || "",
      value: freeText
    };
    this.storeFeedbackField(feedbackField);
  }



  storeFeedbackField(givenFeedbackField:givenFeedbackField){


    let existingFieldIndex = this.currentFeedback.feedbackFields.findIndex(field => field.fieldName === givenFeedbackField.fieldName);

    if (existingFieldIndex !== -1) {
      this.currentFeedback.feedbackFields[existingFieldIndex] = givenFeedbackField;
    } else {
      this.currentFeedback.feedbackFields.push(givenFeedbackField);
    }

    this.feedbackService.setFeedbackValues(this.currentFeedback!);

  }

  storeInputsValuesIntoFeedbackResponse(inputValue:number | string, type: string){

    switch(type){
      case 'reason':
        {

          this.currentFeedback= {
            ...this.currentFeedback,
            closingTradeData: {
              ...this.currentFeedback.closingTradeData,
              closingReasonId: inputValue as number
            }
          };

          this.feedbackService.setFeedbackValues(this.currentFeedback);
          break;

        }

      case 'open_trade_id':
        {
          this.currentFeedback= {
            ...this.currentFeedback,
            closingTradeData: {
              ...this.currentFeedback.closingTradeData,
              openTradeId: inputValue as number
            }
          };

          this.feedbackService.setFeedbackValues(this.currentFeedback);
          break
        }
      case 'closing_price':
        {
          this.currentFeedback= {
            ...this.currentFeedback,
            closingTradeData: {
              ...this.currentFeedback.closingTradeData,
              closingPrice: inputValue as number
            }
          };

          this.feedbackService.setFeedbackValues(this.currentFeedback);
          break
        }

      default:
        {
          break;
        }
    }
  }

  checkIfAllMandatoryFieldsAreFilled(){
    let areMandatoryFieldsFilled = false;
    let closingDate = this.currentFeedback.closingTradeData?.closingDate;
    let entryPrice = this.currentFeedback.closingTradeData?.tradeEntryPrice;

    if(
      this.closingPrice > 0 &&
      entryPrice != undefined && entryPrice > 0 &&
      this.closingReasonModel.trim() !== '' &&
      this.freeText.trim().split(/\s+/).length >=2 &&
      // this.freeText.trim() !== '' &&
      closingDate
    ){
      areMandatoryFieldsFilled = true;
    }
    // if (
    //   this.selectedFollowedScenario.value &&
    //   this.predictedPrice > 0 &&
    //   this.selectedMonth.value.length > 0 &&
    //   this.selectedYear.value.length > 0 &&
    //   this.selectedDirection &&
    //   this.tradePrice > 0 &&
    //   this.freeText.trim() !== '' &&
    //   runDate &&
    //   this.tradeDate
    // ) {
    //   areMandatoryFieldsFilled = true;
    // }

    this.feedbackService.setAreMandatoryFieldsLoaded(areMandatoryFieldsFilled);
  }
}
